<template>
    <div class="row justify-content-center">
        <template v-if="$route.params.type === 'request'">
            <template v-if="!requested">
                <template v-if="user.profile">
                    <div v-if="!mireraTeacher" class="form-container d-flex flex-column align-items-center" style="--wide: 0">
                        <h2 class="title-text">
                            {{ $t('title.teacherRequest') }}
                        </h2>

                        <h2 class="subtitle-text pt-4 mb-0">
                            {{ $t('message.enterContactInfo') }}
                        </h2>

                        <div class="row mx-0">
                            <div class="col px-4">
                                <ValidationObserver ref="formObserver">
                                    <v-input
                                        v-model="phone"
                                        class="input-w-default mb-0 mt-2"
                                        ind="0"
                                        type="tel"
                                        :placeholder="$t('placeholder.phone')"
                                        :icon="$getInputIcon(phone, 'phone')"
                                        rules="required|phone"
                                    />

                                    <v-input
                                        v-model="work"
                                        class="input-w-default mb-0 mt-2"
                                        ind="1"
                                        type="text"
                                        :placeholder="$t('placeholder.work')"
                                        :icon="$getInputIcon(work, 'work')"
                                        rules="required"
                                    />

                                    <v-input
                                        v-model="position"
                                        class="input-w-default mb-0 mt-2"
                                        ind="2"
                                        type="text"
                                        :placeholder="$t('placeholder.position')"
                                        :icon="$getInputIcon(position, 'position')"
                                        rules="required"
                                    />

                                    <v-input
                                        v-model="comment"
                                        class="input-w-default mb-0 mt-2"
                                        ind="3"
                                        type="text"
                                        :placeholder="$t('placeholder.comment')"
                                        :icon="$getInputIcon(comment, 'comment')"
                                    />
                                </ValidationObserver>

                                <b-button class="enter-button w-75 mb-2" @click="sendRequest">
                                    {{ $t('button.send') }}
                                </b-button>
                            </div>
                        </div>
                    </div>

                    <h2 v-else class="text-white font-weight-light" style="text-align: center">
                        {{ $t('error.alreadyTeacher') }}
                    </h2>
                </template>
            </template>

            <h5 v-else class="text-white mt-5 mb-3">
                {{ $t('message.requestSent') }}
            </h5>
        </template>

        <template v-else>
            <template v-if="!registered">
                <div v-if="!user.profile" class="form-container" style="--wide: 1">
                    <h2 class="title-text wide-title-text px-4">
                        {{ $t('title.teacherRegister') }}
                    </h2>

                    <ValidationObserver ref="registerObserver">
                        <div class="d-flex flex-wrap justify-content-around">
                            <div>
                                <v-input
                                    v-model="surname"
                                    class="input-w-default"
                                    ind="4"
                                    type="text"
                                    :placeholder="$t('placeholder.surname')"
                                    :icon="$getInputIcon(surname, 'name')"
                                    rules="required"
                                />

                                <v-input
                                    v-model="name"
                                    class="input-w-default"
                                    ind="5"
                                    type="text"
                                    :placeholder="$t('placeholder.name')"
                                    :icon="$getInputIcon(name, 'name')"
                                    rules="required"
                                />

                                <v-input
                                    v-model="mail"
                                    class="input-w-default"
                                    ind="8"
                                    type="email"
                                    :placeholder="$t('placeholder.email')"
                                    :icon="$getInputIcon(mail, 'email')"
                                    :debounce="500"
                                    rules="required|email|emailNotExists"
                                />

                                <v-input
                                    v-model="password"
                                    class="input-w-default"
                                    ind="6"
                                    type="password"
                                    name="password"
                                    :placeholder="$t('placeholder.password')"
                                    :icon="$getInputIcon(password, 'password')"
                                    :rules="{required: true, min: 6}"
                                    autocomplete="new-password"
                                />

                                <v-input
                                    v-model="passwordConfirm"
                                    class="input-w-default"
                                    ind="7"
                                    type="password"
                                    name="passwordConfirm"
                                    :placeholder="$t('placeholder.repeatPassword')"
                                    :icon="$getInputIcon(passwordConfirm, 'password')"
                                    rules="required|confirmed:password"
                                    autocomplete="new-password"
                                />
                            </div>

                            <div>
                                <v-input
                                    v-model="phone"
                                    class="input-w-default"
                                    ind="9"
                                    type="tel"
                                    :placeholder="$t('placeholder.phone')"
                                    :icon="$getInputIcon(phone, 'phone')"
                                    rules="required|phone"
                                />

                                <v-input
                                    v-model="work"
                                    class="input-w-default"
                                    ind="10"
                                    type="text"
                                    :placeholder="$t('placeholder.work')"
                                    :icon="$getInputIcon(work, 'work')"
                                    rules="required"
                                />

                                <v-input
                                    v-model="position"
                                    class="input-w-default"
                                    ind="11"
                                    type="text"
                                    :placeholder="$t('placeholder.position')"
                                    :icon="$getInputIcon(position, 'position')"
                                    rules="required"
                                />

                                <v-input
                                    v-model="comment"
                                    class="input-w-default"
                                    ind="12"
                                    type="text"
                                    :placeholder="$t('placeholder.commentForAdmin')"
                                    :icon="$getInputIcon(comment, 'comment')"
                                />
                            </div>
                        </div>

                        <ValidationProvider v-slot="{ errors }" :rules="{isTrue: true}" slim>
                            <b-form-checkbox id="confirmUserAgreementAndPrivacyPolicy" v-model="confirmUserAgreementAndPrivacyPolicy" class="text-white small agreements-checkbox">
                                {{ $t('message.acceptTerms') }}
                                
                                <br>
                                
                                <router-link class="text-link" to="/user-agreement" target="_blank">
                                    {{ $t('title.userAgreementGenitive') }}
                                </router-link>
                                
                                {{ $t('message.and') }}
                                
                                <br>
                                
                                <router-link class="text-link" to="/privacy-policy" target="_blank">
                                    {{ $t('title.privacyPolicyGenitive') }}
                                </router-link>
                            </b-form-checkbox>

                            <b-popover v-if="errors.length" target="confirmUserAgreementAndPrivacyPolicy" placement="left" variant="danger" show>
                                {{ $t('message.confirmTerms') }}
                            </b-popover>
                        </ValidationProvider>
                        
                        <ValidationProvider v-slot="{ errors }" :rules="{isTrue: true}" slim>
                            <b-form-checkbox id="confirmPersonalDataAgreement" v-model="confirmPersonalDataAgreement" class="text-white small mx-auto agreements-checkbox">
                                {{ $t('message.acceptPersonalDataAgreement') }}
                                
                                <router-link class="text-link" to="/personal-data-agreement" target="_blank">
                                    {{ $t('title.personalDataAgreement') }}
                                </router-link>
                            </b-form-checkbox>
    
                            <b-popover v-if="errors.length" target="confirmPersonalDataAgreement" placement="left" variant="danger" show>
                                {{ $t('message.confirmTerms') }}
                            </b-popover>
                        </ValidationProvider>

                        <b-form-invalid-feedback v-if="error !== ''" class="center-element">
                            {{ error }}
                        </b-form-invalid-feedback>

                        <b-form-checkbox id="acceptedMailing" v-model="acceptedMailing" class="text-white small mailing-checkbox">
                            {{ `${$t('message.acceptedMailing')}&nbsp;` }}
                        </b-form-checkbox>

                        <b-button :disabled="!confirmUserAgreementAndPrivacyPolicy || !confirmPersonalDataAgreement" class="center-element enter-button px-5 mb-2" @click="register">
                            {{ $t('button.register') }}
                        </b-button>
                    </ValidationObserver>
                </div>

                <h2 v-else class="text-white font-weight-light text-center">
                    {{ $t('error.alreadyRegistered') }}
                </h2>
            </template>

            <div v-else class="col mb-3 text-center">
                <div class="row justify-content-center">
                    <h5 class="text-white mt-5">
                        {{ $t('message.lastStepToRegister') }}
                    </h5>
                </div>

                <div class="row justify-content-center">
                    <h6 class="text-white">
                        {{ `${$t('message.checkActivationMail')}:&nbsp;` }}<strong>{{ mail }}</strong>

                        <br>

                        <div class="d-flex justify-content-center">
                            {{ $t('message.expireDateWarning') }}
                        </div>
                    </h6>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import api from '@/api';
    import VInput from './VInput';
    import { mapState } from 'vuex';

    export default {
        name: 'PermissionsRequest',

        components: {
            VInput
        },

        data() {
            return {
                requested: false,
                registered: false,
                surname: '',
                name: '',
                mail: '',
                password: '',
                passwordConfirm: '',
                phone: '',
                work: '',
                position: '',
                comment: '',
                confirmUserAgreementAndPrivacyPolicy: false,
                confirmPersonalDataAgreement: false,
                error: '',
                acceptedMailing: false
            };
        },

        computed: {
            ...mapState({ user: state => state.user }),

            mireraTeacher() {
                return this.user.profile ? this.user.profile.permissions.mirera === this.$defines.SERVICE_ACCOUNT_TYPES.TEACHER : false;
            }
        },

        async created() {
            if (![ 'request', 'register' ].includes(this.$route.params.type))
                await this.$router.push('/not-found');
        },

        methods: {
            async sendRequest() {
                let validate = await this.$refs.formObserver.validate();

                if (validate) {
                    try {
                        await api.post('/app/account/permissions/mirera/request', {
                            phone: this.phone,
                            work: this.work,
                            position: this.position,
                            comment: this.comment
                        });

                        this.requested = true;
                    }
                    catch (e) {
                        this.requested = false;
                        this.error = this.$t('error.requestSendingFailed');
                    }
                }

            },

            async register() {
                let isValid = await this.$refs.registerObserver.validate();

                if (isValid) {
                    try {
                        await api.post('/app/registration/register', {
                            type: this.$defines.SERVICE_ACCOUNT_TYPES.TEACHER,
                            name: this.name,
                            surname: this.surname,
                            mail: this.mail,
                            password: this.password,
                            phone: this.phone,
                            work: this.work,
                            position: this.position,
                            comment: this.comment,
                            acceptedMailing: this.acceptedMailing
                        });

                        this.registered = true;
                    }
                    catch (e) {
                        this.registered = false;
                        this.error = this.$t('registerFailed');
                    }
                }
            }
        }
    };
</script>

<style scoped>
    .title-text {
        font-weight: lighter !important;
        font-size: 23px;
        line-height: 27px;
        text-decoration: none !important;
        padding-bottom: 2px;
        border-bottom: 1px solid #FFFFFF;
        color: white;
        text-align: center;
        text-decoration-skip-ink: none;
    }

    .wide-title-text {
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
    }

    .subtitle-text {
        font-weight: lighter !important;
        font-size: 18px;
        line-height: 20px;
        text-decoration: none !important;
        color: white;
        text-align: center;
    }

    .enter-button {
        background-color: transparent !important;
        border: 1px solid #36AB71 !important;
        border-radius: 5px !important;
        margin-top: 1.7rem !important;
        display: flex !important;
        flex-direction: row !important;
        justify-content: center !important;
        margin-left: auto !important;
        margin-right: auto !important;
    }

    .enter-button:hover:not(:disabled) {
        background-color: #36AB71 !important;
    }

    .text-link {
        color: #29ABE2 !important;
    }

    .input-w-default {
        max-width: 304px;
        min-width: 304px;
        padding-left: 0;
        padding-right: 0;
    }

    .agreements-checkbox {
        margin: 28px auto 24px!important;
        width: fit-content;
        max-width: 304px;
        min-width: 304px;
    }

    .mailing-checkbox {
        margin: 28px auto 24px !important;
        width: fit-content;
        max-width: 304px;
        min-width: 304px;
    }

    /deep/ .custom-control-label::before, /deep/ .custom-control-label::after {
        top: 0.125rem;
    }

    @media screen and (min-width: 400px) {
        .form-container {
            width: calc(var(--wide) * 750px + (1 - var(--wide)) * 400px) !important;
        }
    }
</style>
